<template>
  <li class="nav-item">
    <!-- for tablet, desktop -->
    <div class="dropdown d-none d-lg-block">
      <router-link :class="pageClass + ' ub-link nav-link'" :to="'/' + title.toLowerCase()">
        {{title}}
        <DirectionArrow></DirectionArrow>
      </router-link>

      <div :class="pageClass + ' dropdown-content'">
        <router-link
          v-for="item in menuDropdown"
          :key="item.name"
          class="ub-dropdown-item dropdown-item"
          :to="item.to"
        >{{item.name}}</router-link>
      </div>
    </div>

    <!-- for mobile -->
    <router-link
      :class="pageClass + ' nav-link d-sm-block d-md-block d-lg-none'"
      id="navbarMultiLevelDropdown"
      :to="'/' + title.toLowerCase()"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      data-target="#navbarSupportedContent"
    >{{ title }}</router-link>

    <div class="dropdown-menu show d-lg-none">
      <router-link
        v-for="item in menuDropdown"
        :key="item.name"
        class="dropdown-item"
        :to="item.to"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
      >{{item.name}}</router-link>
    </div>
  </li>
</template>

<script>
import DirectionArrow from "@/components/utils/direction-arrow";

export default {
  name: "NavbarMenuMultiLevelItem",

  components: {
    DirectionArrow
  },

  props: {
    title: {
      type: String,
      default: ""
    },
    pageClass: {
      type: String,
      default: "black-navbar"
    },
    menuDropdown: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.ub-link {
  display: inline-block;
}

.black-navbar {
  background: #1b2e38;
  color: white;
}

.white-navbar {
  background: transparent;
  color: black;
}

.black-navbar .dropdown-content {
  background: #1b2e38;
  color: white;
}

.white-navbar .dropdown-content {
  color: black;
}

/* ---------------------------------------------------
  dropdown content styling
----------------------------------------------------- */
.dropdown {
  position: relative;
  cursor: pointer;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  top: 2.5rem;

  width: auto;
  text-align: left;

  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 100;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: inherit;
  font-size: 1rem;
  text-decoration: none;
  padding: 12px 22px;
  cursor: pointer;
}

.white-navbar .dropdown-content a:hover {
  background-color: #ebebeb;
}

.black-navbar .dropdown-content a:hover {
  background-color: #37a8bd;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

.ub-dropdown-item {
  padding: 0 1rem;
  border-radius: 4px;
}

.black-navbar .dropdown-menu {
  background-color: #15222d;
}

.black-navbar .dropdown-menu .dropdown-item {
  color: white;
}

.dropdown-menu .dropdown-item:active,
.dropdown-menu .dropdown-item:focus {
  background-color: transparent;
}

@media (min-width: 992px) {
  .ub-link {
    margin-right: 0.5rem;
  }
}

@media (min-width: 1200px) {
  .ub-link {
    margin-right: 2rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/fixed/navbar/navbar-menu-multi-level-item.vue